export const ADD_TARGET = 'ADD_TARGET'
export const CURRENT_TARGET = 'CURRENT_TARGET'
